import { BladeDamageSimilarsRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: [],
    damages: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
    damages (state, data) {
      state.damages = []
      state.damages = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamageSimilarsRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, obj) {
      return new Promise((resolve, reject) => {
        BladeDamageSimilarsRepository.create(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    delete (context, obj) {
      return new Promise((resolve, reject) => {
        BladeDamageSimilarsRepository.delete(obj)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
    damages ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamageSimilarsRepository.getAllDamages(obj)
          .then(response => {
            const data = response.data.data
            commit('damages', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
  }
}
